<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class AdditionalFeesModal extends Vue {
        render() {
            return null
        }
    }

    export default AdditionalFeesModal
</script>
